module.exports = __webpack_public_path__ + "media/images/lb/941-2e0fc2f9078c6aa282ff25951138faa5.svg";